<template>
  <a-modal
    :visible="visible.batchReplaceRaw"
    :bodyStyle="{ paddingTop: '10px' }"
    :destroyOnClose="true"
    width="900px"
    :forceRender="true"
    okText="确定替换"
    @ok="ok"
    @cancel="toggleVisible('batchReplaceRaw')">
    <span class="title" slot="title">批量替换原料 <b>在沿用约束条件的情况下，替换配方中指定原料</b></span>
    <div class="raw-model-info-row">
      已选中配方：
      <span>{{ formulaSelectedRows.map((item) => `【${item.formulaName}】`).join(',') }}</span>
    </div>
    <div class="raw-model-info-row">替换原料明细：</div>
    <a-spin :spinning="replaceLoading" tip="原料替换中" style="margin-bottom: 2em">
      <a-row :gutter="[16, 16]">
        <a-col :span="3"></a-col>
        <a-col :span="8">
          <div class="col-title">
            <span>新增原料</span>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="col-title">
            <span>配方中被替换原料</span>
          </div>
        </a-col>
      </a-row>
      <a-row v-for="(item, index) in items" :key="item.key" :gutter="[16, 16]">
        <a-col :span="3"></a-col>
        <a-col :span="8">
          <a-select v-model="item.rawId" placeholder="输入原料名称/代码" style="width: 100%" showSearch optionFilterProp="children">
            <a-select-option v-for="raw in rawList" :value="raw.rawId" :key="raw.rawId"> {{ raw.name }}({{ raw.code }}) </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="8">
          <a-select v-model="item.rawReplaceId" placeholder="输入被替换原料名称/代码" style="width: 100%" showSearch optionFilterProp="children">
            <a-select-option v-for="raw in formulaRawList" :value="raw.rawId" :key="raw.rawId"> {{ raw.rawName }}({{ raw.rawCode }}) </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="2">
          <a-icon v-if="index == 0 && items.length < 10" type="plus-circle" style="font-size: 22px; color: #39a0ff; margin-right: 0.5em" @click="addRow" />
          <a-icon v-if="index > 0" type="minus-circle" style="font-size: 22px; color: #39a0ff" @click="delRow(index)" />
        </a-col>
      </a-row>
    </a-spin>
  </a-modal>
</template>

<script>
import { formulaMixins } from '../unitls';
export default {
  mixins: [formulaMixins],
  data() {
    return {
      replaceLoading: false,
      rawList: [],
      formulaRawList: [],
      items: [{}, {}, {}, {}, {}],
    };
  },

  watch: {
    'visible.batchReplaceRaw'(val) {
      val ? this.getRawList() : this.reset();
    },
  },

  methods: {
    ok() {
      // 校验this.items里是否有重复的数据，判断依据为rawId或者rawReplaceId有重复项
      let flag = true;
      const temp_set = new Set();
      this.items.forEach((item) => {
        if (!item.rawId || !item.rawReplaceId) {
          return;
        }
        if (item.rawId == item.rawReplaceId || temp_set.has(item.rawId) || temp_set.has(item.rawReplaceId)) {
          flag = false;
        } else {
          temp_set.add(item.rawId);
          temp_set.add(item.rawReplaceId);
        }
      });

      if (flag) {
        this.$confirm({
          title: '批量替换原料',
          content: '确定将配方中的原料进行替换吗？',
          cancelText: '取消',
          okText: '确定',
          onOk: () => {
            this.batchRepalceRaw();
          },
          onCancel: () => {},
        });
      } else {
        this.$message.error('操作失败：【新增原料】与【配方中被替换原料】中存在相同原料');
      }
    },
    async batchRepalceRaw() {
      const replaceFormulaRawObjList = this.items
        .filter((item) => {
          return item.rawId && item.rawReplaceId;
        })
        .map((item) => ({ rawId: item.rawId, rawReplaceId: item.rawReplaceId }));
      // 如果数据为空直接返回
      if (replaceFormulaRawObjList.length == 0) {
        this.toggleVisible('batchReplaceRaw');
        return;
      }
      const data = { replaceFormulaRawObjList, taskId: this.taskId, taskFormulaIdList: this.formulaSelectedRowKeys };
      await this.$http.post('/nhf-app/formulataskraw/batchReplaceFormulaRawAndTaskRaw', data);
      this.$message.success('替换成功');
      this.toggleVisible('batchReplaceRaw');
      this.$emit('ok');
      this.$emit('refresh');
    },
    getRawList() {
      this.fetchGet({
        actions: this.myRawpage,
        name: 'list',
        data: {
          factoryId: window.localStorage.getItem('factoryId'),
          size: 99999,
          current: 1,
        },
      }).then((res) => {
        if (res.success) {
          this.rawList = res.data.records;
        }
      });
      this.fetchGet({
        actions: this.selectReplaceTaskFormulaRaw,
        name: 'list',
        data: {
          taskFormulaIds: this.formulaSelectedRowKeys.join(','),
          factoryId: window.localStorage.getItem('factoryId'),
          size: 2000,
        },
      }).then((res) => {
        if (res.success) {
          this.formulaRawList = res.data;
        }
      });
    },

    reset() {
      this.rawList = [];
      this.formulaRawList = [];
      this.items =[{}, {}, {}, {}, {}];
    },

    addRow() {
      this.items.push({});
    },
    delRow(index) {
      this.items.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;

  b {
    font-size: 12px;
    font-weight: normal;
    color: #999;
    margin-left: 10px;
  }
}

.raw-model-info-row {
  margin-bottom: 8px;

  span {
    color: #999;
  }
}

.col-title {
  text-align: center;

  span {
    border: 1px solid rgba(235, 235, 235, 1);
    background-color: rgba(247, 247, 247, 1);
    padding: 0 0.5em 0.2em;
    border-radius: 4px;
  }
}
</style>
